import { render, staticRenderFns } from "./PosModalActiveCar.template.vue?vue&type=template&id=c63bcf96&scoped=true&"
var script = {}
import style0 from "./PosModalActiveCar.template.vue?vue&type=style&index=0&id=c63bcf96&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63bcf96",
  null
  
)

export default component.exports